import { requirePermission } from '@/utils/auth'
import { createFileRoute, redirect } from '@tanstack/react-router'
import dayjs from 'dayjs'

export const Route = createFileRoute('/hotline-calls')({
  beforeLoad: ({ location }) => {
    requirePermission('hotline')

    if (location.pathname === '/hotline-calls' || location.pathname === '/hotline-calls/') {
      const now = dayjs()
      const endDate = dayjs(now.toDate()).format('YYYY-MM-DD')
      const startDate = dayjs(now.subtract(24, 'hour').toDate()).format('YYYY-MM-DD')

      throw redirect({
        to: '/hotline-calls/$startDate/$endDate',
        params: {
          startDate,
          endDate,
        },
      })
    }
  },
})
